import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

const useStyles = makeStyles({
  button: {
    color: '#FFF',
    backgroundColor: '#009688',
    letterSpacing: '1px',
    '&:hover': {
      backgroundColor: '#4db6ac',
      borderColor: '#4db6ac',
    },
  },
});

const StyledButton = ({ text, onClickHandler }) => {
  const classes = useStyles();

  const handleOnClick = (e) => {
    onClickHandler(e);
  };

  return (
    <Button className={classes.button} variant="contained" onClick={handleOnClick}>
      {text}
    </Button>
  );
};

export default StyledButton;
